import React from 'react';

export default function LocalOpeningRollModal({
  leftLabel,
  rightLabel,
  leftValue,
  rightValue,
  rolling,
  resultText,
  onRoll,
}) {
  const showResult = Boolean(resultText);

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.badge}>Opening Roll</div>
        <h2 style={styles.title}>Roll To Start</h2>
        <div style={styles.subtitle}>
          Highest opening roll gets the first move.
        </div>

        <div style={styles.scoreRow}>
          <div style={styles.playerCard}>
            <div style={styles.playerLabel}>{leftLabel}</div>
            <div style={styles.rollValue}>{leftValue}</div>
          </div>
          <div style={styles.vsPill}>vs</div>
          <div style={styles.playerCard}>
            <div style={styles.playerLabel}>{rightLabel}</div>
            <div style={styles.rollValue}>{rightValue}</div>
          </div>
        </div>

        {showResult ? (
          <>
            <div style={styles.resultText}>{resultText}</div>
            <div style={styles.autoCloseNote}>Starting game in 5 seconds...</div>
          </>
        ) : (
          <>
            <div style={styles.statusNote}>
              {rolling ? 'Rolling dice...' : 'Tap below to roll for the first move.'}
            </div>
            <button
              type="button"
              onClick={onRoll}
              disabled={rolling}
              style={{
                ...styles.primaryBtn,
                ...(rolling ? styles.primaryBtnDisabled : {}),
              }}
            >
              {rolling ? 'Rolling...' : 'Roll Dice'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(7, 3, 1, 0.38)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    zIndex: 2500,
  },
  card: {
    width: 'min(100%, 520px)',
    background: 'linear-gradient(180deg, rgba(46, 24, 13, 0.98), rgba(27, 14, 8, 0.98))',
    border: '1px solid rgba(215,177,106,0.38)',
    borderRadius: 18,
    boxShadow: '0 18px 48px rgba(0,0,0,0.42)',
    padding: 24,
    display: 'grid',
    gap: 16,
    textAlign: 'center',
  },
  badge: {
    justifySelf: 'center',
    border: '1px solid rgba(215,177,106,0.45)',
    background: 'rgba(122, 76, 34, 0.26)',
    color: '#f3d392',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
  },
  title: {
    margin: 0,
    color: '#f6e7c1',
    fontSize: 30,
    fontWeight: 800,
    lineHeight: 1.05,
  },
  subtitle: {
    color: '#d8c3a0',
    fontSize: 15,
    lineHeight: 1.5,
  },
  scoreRow: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    gap: 12,
    alignItems: 'center',
  },
  playerCard: {
    display: 'grid',
    gap: 8,
    padding: 16,
    borderRadius: 14,
    border: '1px solid rgba(215,177,106,0.22)',
    background: 'rgba(255,255,255,0.03)',
  },
  playerLabel: {
    color: '#d8c3a0',
    fontSize: 14,
    fontWeight: 700,
  },
  rollValue: {
    color: '#fff3d3',
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1,
    minHeight: 40,
  },
  vsPill: {
    color: '#d7b16a',
    fontSize: 18,
    fontWeight: 800,
  },
  statusNote: {
    color: '#e7c98a',
    fontSize: 16,
    lineHeight: 1.45,
    minHeight: 24,
  },
  resultText: {
    color: '#f6e7c1',
    fontSize: 18,
    lineHeight: 1.45,
  },
  autoCloseNote: {
    color: '#e7c98a',
    fontSize: 14,
    fontWeight: 700,
  },
  primaryBtn: {
    border: '1px solid #d7b16a',
    background: '#7a4c22',
    color: '#f6e7c1',
    borderRadius: 12,
    padding: '12px 16px',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 800,
  },
  primaryBtnDisabled: {
    opacity: 0.62,
    cursor: 'default',
  },
};
